import theme from '@/config/theme';
import styled from 'vue-styled-components';

export const Main = styled.main`
  display: grid;
  grid-template-rows: 0.3fr 0.7fr;
  row-gap: 2rem;
  padding: 1rem;
  height: 100%;
  padding-top: 130px;

  > .contentLeft {
    justify-self: flex-end;
    display: flex;
    column-gap: 2rem;
    align-items: center;
    font-weight: 600;
    font-size: max(.8rem, 1vw);

    .filters {
      display: flex;
      align-items: center;
      column-gap: 1rem;
      row-gap: .5rem;
      flex-wrap: wrap;
    }

    .createVoucher {
      display: flex;
      align-items: center;
      column-gap: .5rem;

      span {
      font-size: inherit;
    }

    button {
      font-size: inherit;
      font-weight: inherit;
      padding: 0.5rem;
      justify-self: flex-end;

      &:hover {
        cursor: pointer;
        color: white;
      }
    }
    }
  }

  .customModal {
    > div {
      max-width: 684px;
      row-gap: 0.5rem;
      height: auto;

      .contentInput {
        width: 100%;
        display: flex;
        flex-direction: column;
        row-gap: 1rem;

        .contentLabel {
          display: flex;
          flex-direction: column;
          row-gap: 0.2rem;
          width: 100%;

          input {
            background-color: ${theme.colors.gray3};
          }

          .error {
            color: ${theme.colors.supportErrorDark};
          }
        }
      }

      @media all and (max-width: ${theme.grid.mobile.breakpoint}) {
        max-width: 100%;
      }
    }
  }
`;
export const ComponentButton = styled.div`
  display: flex;
  svg {
    width: 1rem;
    height: 1rem;
    fill: currentColor;
  }

  .buttonCustom {
    padding: 0.5rem;
    background-color: ${theme.colors.primaryBlue};
    border-radius: 0.25rem;
    border-width: 1px;
    color: white;

    &:hover {
      background-color: ${theme.colors.info};
      cursor: pointer;
    }

    &:focus {
      outline: none;
    }
  }
  .inputCustom {
    background-color: white;
    appearance: none;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
    border-width: 1px;
    font-weight: 600;

    &:focus {
      outline: none;
    }
  }
`;

export const ContentTable = styled.div`
  position: relative;
  display: grid;

  .pagination {
    justify-self: flex-end;
  }
`;
